// extracted by mini-css-extract-plugin
export default {"classroomCard":"ClassroomBox_classroomCard__oYhYk"};